import { ref, watch } from "vue";
import { defineStore } from "pinia";
import skuUtils from "@/internals/sku-utils";
import { useGlobalDiscountStore } from "@/stores/global-discount-store";

export const useCartStore = defineStore("cartStore", () => {
    const globalDiscountStore = useGlobalDiscountStore();
    const items = ref([]);
    const quantity = ref(0);
    const total = ref(0);
    const subTotal = ref(0);
    const discount = ref(0);
    const coupon = ref(0);

    // add to cart item
    function addToCart(payload) {
        // console.log("payload");
        // console.log(payload);

        let cartItem = {};
        // if (items.value.length) {
        //     if (payload?.sourceType == 'bundle') {
        //         cartItem = items.value.find((item) => item.product.code === payload.product.code);
        //     } else
        // }
        cartItem = items.value.find(
            (item) => item?.sku?.code === payload.sku.code
        );
        // console.log("cartItem");
        // console.log(cartItem);
        if (cartItem) {
            cartItem.quantity += payload.quantity;

            // if (payload?.sourceType == 'bundle') {
            //     cartItem.subTotal = Number(payload.salesPrice) * cartItem.quantity;
            //     total.value += Number(payload.salesPrice) * payload.quantity;
            // } else {
            // ca?.price Number(skuUtils.extractPrice(payload.sku)) * cartItem.quantity;
            // total.value +=
            //     Number(skuUtils.extractPrice(payload.sku)) * payload.quantity;
            // }
            cartItem.subTotal =
                globalDiscount(payload.sku, payload.product)?.price *
                cartItem.quantity;
            total.value +=
                globalDiscount(payload.sku, payload.product)?.price * payload.quantity;
            subTotal.value +=
                globalDiscount(payload.sku, payload.product)?.salesPrice * payload.quantity;
            discount.value +=
                globalDiscount(payload.sku, payload.product)?.discount * payload.quantity;

            quantity.value += payload.quantity;
        } else {
            let item = {};

            item.product = payload.product;
            item.sku = payload.sku;
            item.quantity = payload.quantity;
            // item.sourceType = payload?.sourceType == 'bundle' ? 'bundle' : 'item';

            // if (payload?.sourceType == 'bundle') {
            //     item.subTotal = Number(payload.salesPrice) * item.quantity;
            //     total.value += Number(payload.salesPrice) * payload.quantity;
            // } else {
            // item.subTotal =
            //     Number(skuUtils.extractPrice(payload.sku)) * item.quantity;
            // total.value +=
            //     Number(skuUtils.extractPrice(payload.sku)) * payload.quantity;
            // }
            item.subTotal =
                globalDiscount(payload.sku, payload.product)?.price * item.quantity;
            subTotal.value +=
                globalDiscount(payload.sku, payload.product)?.salesPrice * item.quantity;
            total.value +=
                globalDiscount(payload.sku, payload.product)?.price * item.quantity;
            discount.value +=
                globalDiscount(payload.sku, payload.product)?.discount * item.quantity;
            // console.log("~~~item");
            // console.log(item);
            items.value.push(item);

            quantity.value += payload.quantity;
        }

        // console.log({
        //     items: items.value,
        //     quantity: quantity.value,
        //     total: total.value,
        // });
        if (process.client) {
            localStorage.setItem(
                "cart",
                JSON.stringify({
                    items: items.value,
                    quantity: quantity.value,
                    total: total.value,
                    subTotal: subTotal.value,
                    discount: discount.value,
                })
            );

            try {
                const pixel = useMetaPixel();
                const productId = payload?.product?.id ? String(payload.product.id) : (payload?.sku?.code ? String(payload.sku.code) : "");
                const unitPrice = globalDiscount(payload?.sku, payload?.product)?.price || Number(payload?.sku?.salesPrice || payload?.product?.price || 0);
                const addedQty = Number(payload?.quantity || 1);
                const value = unitPrice * addedQty;
                if (productId) {
                    pixel.trackAddToCart({
                        content_ids: [productId],
                        content_name: payload?.product?.title || payload?.product?.name || "",
                        value: value,
                        currency: "BDT",
                    });
                }
            } catch (e) {}
        }
    }

    // increase item quantity
    function increase(payload) {
        // Find item by SKU code instead of object reference
        const index = items.value.findIndex(
            (item) => item?.sku?.code === payload?.sku?.code
        );
        
        if (index !== -1) {
            let cartItem = items.value[index];
            cartItem.quantity++;
            if (payload?.sourceType == "bundle") {
                cartItem.subTotal = Number(payload.salesPrice) * cartItem.quantity;
                total.value += Number(payload.salesPrice);
                subTotal.value += Number(payload.salesPrice);
            } else {
                cartItem.subTotal = globalDiscount(payload.sku, payload.product)?.price * cartItem.quantity;
                subTotal.value += globalDiscount(payload.sku, payload.product)?.salesPrice;
                total.value += globalDiscount(cartItem.sku, payload.product)?.price;
                discount.value += globalDiscount(cartItem.sku, payload.product)?.discount;
            }
            quantity.value++;
        }
        localStorage.setItem("cart", JSON.stringify({ items: items.value, quantity: quantity.value, total: total.value, subTotal: subTotal.value, discount: discount.value }));
    }

    // decrease items quantity
    function decrease(payload) {
        const index = items.value.findIndex(
            (item) => item?.sku?.code === payload?.sku?.code
        );
        if (index != -1) {
            let cartItem = items.value[index];
            if (cartItem.quantity > 1) {
                cartItem.quantity--;
                if (payload?.sourceType == "bundle") {
                    cartItem.subTotal =
                        Number(payload.salesPrice) * cartItem.quantity;
                    total.value -= Number(payload.salesPrice);
                    subTotal.value -= Number(payload.salesPrice);

                    //             cartItem.subTotal =
                    //   globalDiscount(payload.sku, payload.product) * cartItem.quantity;

                    // total.value -= globalDiscount(cartItem.sku, payload.product);
                } else {
                    // cartItem.subTotal =
                    //     Number(skuUtils.extractPrice(payload.sku)) *
                    //     cartItem.quantity;
                    // total.value -= Number(skuUtils.extractPrice(cartItem.sku));

                    cartItem.subTotal =
                        globalDiscount(payload.sku, payload.product)?.price *
                        cartItem.quantity;
                    subTotal.value -= globalDiscount(payload.sku, payload.product)?.salesPrice;
                    total.value -= globalDiscount(
                        cartItem.sku,
                        payload.product
                    )?.price;
                    discount.value -= globalDiscount(
                        cartItem.sku,
                        payload.product
                    )?.discount;
                }
                // cartItem.subTotal = Number(skuUtils.extractPrice(payload.sku)) * cartItem.quantity;
                // total.value -= Number(skuUtils.extractPrice(cartItem.sku));

                quantity.value--;
            }
        }

        localStorage.setItem(
            "cart",
            JSON.stringify({
                items: items.value,
                quantity: quantity.value,
                total: total.value,
                subTotal: subTotal.value,
                discount: discount.value,
            })
        );
    }
    /* Add Coupon discount amount */
    const addCoupon = (amount) => {
        coupon.value = amount;
    };

    // remove cart item
    function removeCartItem(payload) {
        // Find item by SKU code instead of object reference
        const index = items.value.findIndex(
            (item) => item?.sku?.code === payload?.sku?.code
        );
        
        if (index !== -1) {
            let cartItem = items.value[index];

            quantity.value -= cartItem.quantity;

            if (payload?.sourceType == "bundle") {
                total.value -= Number(payload.salesPrice) * cartItem.quantity;
                subTotal.value -= Number(payload.salesPrice) * cartItem.quantity;
            } else {
                subTotal.value -= globalDiscount(payload.sku, payload.product)?.salesPrice * cartItem.quantity;
                total.value -= globalDiscount(payload.sku, payload.product)?.price * cartItem.quantity;
                discount.value -= globalDiscount(payload.sku, payload.product)?.discount * cartItem.quantity;
            }
            
            // Use splice for proper Vue reactivity
            items.value.splice(index, 1);

            localStorage.setItem(
                "cart",
                JSON.stringify({
                    items: items.value,
                    quantity: quantity.value,
                    total: total.value,
                    subTotal: subTotal.value,
                    discount: discount.value,
                })
            );
        }
    }

    // remove all cart items
    function removeAll() {
        quantity.value = 0;
        items.value = [];
        total.value = 0;
        coupon.value = 0;
        subTotal.value = 0;
        discount.value = 0;

        localStorage.setItem(
            "cart",
            JSON.stringify({
                items: [],
                quantity: 0,
                total: 0,
                subTotal: 0,
                discount: 0,
            })
        );
    }

    function globalDiscount(sku, item) {
        if (!item?.id) {
            return { 
                price: Number(sku?.salesPrice) || 0, 
                salesPrice: Number(sku?.salesPrice) || 0, 
                discount: 0
            };
        }

        if (!globalDiscountStore?.discounts?.length) {
            return { 
                price: Number(sku?.salesPrice) || 0, 
                salesPrice: Number(sku?.salesPrice) || 0, 
                discount: 0
            }
        }

        let discountPrice = 0;
        let discount = 0;
        let appliedDiscount = 0;
        let salesPrice = Number(sku?.salesPrice) || 0;
        let categoryId = item?.categories?.[0]?.id;
        let findSizeSku = sku?.code;
        let itemId = item?.id;

        // Find the best (highest) discount applicable for this item
        globalDiscountStore.discounts.forEach((element) => {
            if (!element?.valid) return;
            
            let currentDiscount = 0;
            let isApplicable = false;

            // Check FIXED_PRODUCT discount
            if (element.type === "FIXED_PRODUCT") {
                let findItem = element?.items?.length && 
                    element.items.filter((i) => i.itemId === itemId);
                
                if (findItem?.length) {
                    if (findItem[0]?.skuCode?.length) {
                        // SKU-specific discount
                        if (findItem[0].skuCode === findSizeSku) {
                            isApplicable = true;
                        }
                    } else {
                        // Product-level discount (any SKU)
                        isApplicable = true;
                    }
                }
            }
            
            // Check FIXED_CATEGORY discount
            if (element.type === "FIXED_CATEGORY" && element?.categories?.length) {
                let findCategory = element.categories.filter((i) => i.categoryId === categoryId);
                if (findCategory?.length) {
                    isApplicable = true;
                }
            }

            // Calculate discount amount
            if (isApplicable) {
                if (element.discountType === "PERCENTAGE") {
                    currentDiscount = Math.floor((salesPrice * Number(element.value)) / 100);
                } else {
                    currentDiscount = Number(element.value);
                }
                
                // Keep the highest discount
                if (currentDiscount > appliedDiscount) {
                    appliedDiscount = currentDiscount;
                    discountPrice = salesPrice - appliedDiscount;
                }
            }
        });
        
        return { 
            price: discountPrice > 0 ? discountPrice : salesPrice, 
            salesPrice: salesPrice, 
            discount: appliedDiscount
        };
    }

    // initial read and set items
    function initialize() {
        if (process.client) {
            let cartJson = localStorage.getItem("cart");
            if (cartJson != null) {
                let cart = JSON.parse(cartJson);

                items.value = cart.items || [];

                quantity.value = Number(cart.quantity);

                // Try to recalculate totals from items using current global discount values
                // This ensures discount is always calculated from the latest global discounts
                if (items.value?.length && globalDiscountStore?.discounts?.length) {
                    recalculateTotals();
                } else {
                    // Fallback to stored values if global discounts not available yet
                    total.value = Number(cart.total) || 0;
                    subTotal.value = Number(cart.subTotal) || 0;
                    discount.value = Number(cart.discount) || 0;
                }
            }
            let data = JSON.parse(localStorage.getItem("coupon"));
            if (data?.amount) {
                coupon.value = data.amount;
            }
        }
    }

    // Recalculate cart totals from items using global discounts
    function recalculateTotals() {
        // Reset all values first
        total.value = 0;
        subTotal.value = 0;
        discount.value = 0;
        quantity.value = 0;

        // Calculate from scratch
        items.value.forEach((item) => {
            if (item?.sku && item?.product) {
                const discountInfo = globalDiscount(item.sku, item.product);
                const qty = item.quantity || 1;
                
                subTotal.value += (Number(discountInfo.salesPrice) || 0) * qty;
                total.value += (Number(discountInfo.price) || 0) * qty;
                discount.value += (Number(discountInfo.discount) || 0) * qty;
                quantity.value += qty;
            }
        });

        // Save to localStorage
        if (process.client) {
            localStorage.setItem(
                "cart",
                JSON.stringify({
                    items: items.value,
                    quantity: quantity.value,
                    total: total.value,
                    subTotal: subTotal.value,
                    discount: discount.value,
                })
            );
        }
    }

    // Watch for global discount changes and recalculate totals
    watch(
        () => globalDiscountStore.discounts,
        (newDiscounts) => {
            if (newDiscounts?.length && items.value?.length) {
                recalculateTotals();
            }
        },
        { deep: true }
    );

    return {
        items,
        quantity,
        total,
        subTotal,
        discount,
        coupon,
        addToCart,
        increase,
        decrease,
        addCoupon,
        removeCartItem,
        removeAll,
        initialize,
        recalculateTotals,
    };
});
